import script from "./examination-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./examination-table.vue?vue&type=script&setup=true&lang=ts"

import "./examination-table.vue?vue&type=style&index=0&id=7b28e42f&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b28e42f"]])

export default __exports__